<template>
    <aside>
        <header>
            <router-link to="/" class="logoLink"><img class="logo" src="../../common/assets/logo-color-round.svg"><span>Flyspot</span>
            </router-link>
        </header>
        <nav @focusin="focusin">
            <div class="menu-group" v-if="isAdmin || isManager">
                <router-link to="/" class="title">
                    <span class="icon ion ion-ios-desktop"></span>
                    <span class="text">{{ $t('common.menu.dashboard') }}</span>
                </router-link>
            </div>
            <div class="menu-group">
                <router-link to="/user/myProfile" class="title">
                    <span class="sup"
                          v-if="$store.state.commonData.data?.countNotViewedOwnedFiles">
                        {{ $store.state.commonData.data.countNotViewedOwnedFiles }}
                    </span>
                    <span class="icon ion ion-ios-person"></span>
                    <span class="text">{{ $t('common.menu.my profile') }}</span>
                </router-link>
            </div>
            <div class="menu-group"
                 v-if="$store.getters.canAnything('user.show')|| $store.getters.canAnything('user.showReport')||$store.getters.canAnything('user.stafftime')">
                <router-link to="/user" class="title" @click.native="toggle">
                    <span class="icon ion ion-ios-people"></span>
                    <span class="text">{{ $t('common.menu.user management') }}</span>
                    <span class="arrow" @click.prevent/>
                </router-link>
                <div class="content">
                    <router-link v-if=" $store.getters.canAnything('user.show')" to="/user">
                        {{ $t('common.menu.user list') }}
                    </router-link>
                    <router-link v-if=" $store.getters.canAnything('user.stafftime') " to="/user/staffTime">
                        {{ $t('common.menu.staff time') }}
                    </router-link>
                    <router-link v-if=" $store.getters.canAnything('user.showReport')" to="/user/report">
                        {{ $t('common.menu.report') }}
                    </router-link>
                    <router-link v-if="isAdmin" to="/user/archive">{{ $t('common.menu.archive') }}</router-link>
                </div>
            </div>
            <div class="menu-group" v-if="isAdmin || isManager">
                <router-link to="/attendanceLog" class="title" @click.native="toggle">
                    <span class="icon ion ion-ios-finger-print"></span>
                    <span class="text">{{ $t('common.menu.biometric') }}</span>
                    <span class="arrow" @click.prevent/>
                </router-link>
                <div class="content">
                    <router-link to="/attendanceLog">{{ $t('common.menu.logs list') }}</router-link>
                    <router-link to="/biometricReader" v-if="isAdmin">{{ $t('common.menu.readers') }}
                    </router-link>
                    <router-link to="/biometricReader/archive" v-if="isAdmin">
                        {{ $t('common.menu.archive') }}
                    </router-link>
                </div>
            </div>
            <div class="menu-group" v-if="isAdmin">
                <router-link to="/competence" class="title">
                    <span class="icon ion ion-ios-attach"></span>
                    <span class="text">{{ $t('common.menu.competences') }}</span>
                </router-link>
            </div>
            <div class="menu-group" v-if="isSchedulerAllowed">
                <router-link to="/schedule" class="title" @click.native="toggle">
                    <span class="icon ion ion-md-time"></span>
                    <span class="text">{{ $t('common.menu.schedule') }}</span>
                    <span class="arrow" @click.prevent/>
                </router-link>
                <div class="content">
                    <router-link to="/schedule">{{ $t('common.menu.schedule') }}</router-link>
                    <router-link v-if="isAdmin|| isManager" to="/schedule/replacement">{{
                            $t('common.menu.replacement')
                        }}
                    </router-link>
                    <router-link to="/schedule/dayInfo">{{ $t('common.menu.day info') }}</router-link>
                    <router-link v-if="$store.getters.canAnything('team.show')" to="/team">{{
                            $t('common.menu.teams')
                        }}
                    </router-link>
                </div>
            </div>
            <div class="menu-group" v-if="isAdmin || isManager">
                <router-link to="/visualization/timeline" class="title">
                    <span class="icon ion ion-ios-list-box"></span>
                    <span class="text">{{ $t('common.menu.timeline') }}</span>
                </router-link>
            </div>
            <div class="menu-group" v-if="isAdmin || hasClearanceSlips">
                <router-link :to="isAdmin || isManager ?'/clearanceSlip' : '/clearanceSlip/my'"
                             class="title" @click.native="toggle">
                    <span class="icon ion ion-ios-albums"></span>
                    <span class="text">{{ $t('common.menu.clearance slip') }}</span>
                    <span class="arrow" @click.prevent/>
                </router-link>
                <div class="content">
                    <router-link v-if="isAdmin || isManager" to="/clearanceSlip">
                        {{ $t('common.menu.list') }}
                    </router-link>
                    <router-link v-if="hasClearanceSlips" to="/clearanceSlip/my">
                        {{ $t('common.menu.my clearance slips') }}
                    </router-link>
                    <router-link v-if="isAdmin" to="/clearanceSlip/tasks">
                        {{ $t('common.menu.tasks') }}
                    </router-link>
                    <router-link v-if="isAdmin" to="/clearanceSlip/group">
                        {{ $t('common.menu.roles') }}
                    </router-link>
                </div>
            </div>
            <div class="menu-group" v-if="isAdmin || isManager">
                <router-link to="/mismatch" class="title">
                    <span class="icon ion ion-ios-warning"></span>
                    <span class="text">{{ $t('common.menu.mismatches') }}</span>
                </router-link>
            </div>
            <div class="menu-group"
                 v-if="(isTimecheckerAllowed || showAdditionalTimechekers || isAdmin) && !$store.getters.hideInTimechecker">
                <router-link to="/shiftReport" class="title">
                    <span class="icon ion ion-ios-time"></span>
                    <span class="text">{{ $t('common.menu.timechecker') }}</span>
                </router-link>
            </div>
            <div class="menu-group"
                 v-if="leaveEnabled||isAdmin || isManager || $store.getters.canAnything('leaves.show')">
                <router-link to="/leave" class="title" @click.native="toggle($event)">
                    <span class="sup"
                          v-if="$store.state.commonData.data.countNotViewedLeaves">{{
                            $store.state.commonData.data.countNotViewedLeaves
                        }}</span>
                    <span class="icon ion ion-ios-happy"></span>
                    <span class="text">{{ $t('common.menu.leaves') }}</span>
                    <span class="arrow" @click.prevent/>
                </router-link>

                <div class="content">
                    <router-link to="/leave/calendar">{{ $t('common.menu.leave calendar') }}</router-link>
                </div>
            </div>
            <div class="menu-group">
                <router-link to="/workersAvailability" class="title" @click.native="toggle($event)">
                    <span class="icon ion ion-ios-walk"></span>
                    <span class="text">{{ $t('common.menu.workersAvailability') }}</span>
                    <span class="arrow" @click.prevent
                          v-if="$store.getters.canAnything('workersAvailability.createRequest')"/>
                </router-link>
                <div class="content" v-if="$store.getters.canAnything('workersAvailability.createRequest')">
                    <router-link to="/workersAvailability/request">{{
                            $t('common.menu.workersAvailability request')
                        }}
                    </router-link>
                </div>
            </div>
            <div class="menu-group">
                <router-link to="/disk" class="title">
                    <span class="sup"
                          v-if="$store.state.commonData.data?.countNotViewedFiles">{{
                            $store.state.commonData.data.countNotViewedFiles
                        }}</span>
                    <span class="sub"
                          v-if="$store.state.commonData.data?.countNotViewedFilesComments">{{
                            $store.state.commonData.data.countNotViewedFilesComments
                        }}</span>
                    <span class="icon ion ion-ios-folder"></span>
                    <span class="text">{{ $t('common.menu.disk') }}</span>
                </router-link>
            </div>
            <div class="menu-group" v-if="isAdmin">
                <router-link to="/log" class="title" @click.native="toggle">
                    <span class="icon ion ion-ios-journal"></span>
                    <span class="text">{{ $t('common.menu.log') }}</span>
                    <span class="arrow" @click.prevent/>
                </router-link>

                <div class="content">
                    <router-link to="/viewed/combined">{{ $t('common.menu.viewsLog') }}</router-link>
                </div>
            </div>
            <div class="menu-group" v-if="$store.getters.canGlobal('commission.manageCommissionProducts')">
                <router-link to="/commission" class="title">
                    <span class="icon ion ion-logo-euro"></span>
                    <span class="text">{{ $t('common.menu.commission') }}</span>
                </router-link>
            </div>

            <div class="menu-group" v-if="$store.getters.canAnything('teams.show')">
                <router-link to="/team" class="title">
                    <span class="icon ion ion-ios-git-network"></span>
                    <span class="text">{{ $t('common.menu.teams') }}</span>
                </router-link>
            </div>
            <div class="menu-group" v-if="$store.getters.canAnything('location.show')">
                <router-link to="/location" class="title" @click.native="toggle">
                    <span class="icon ion ion-ios-pin"></span>
                    <span class="text">{{ $t('common.menu.locations') }}</span>
                    <span class="arrow" @click.prevent/>
                </router-link>
                <div class="content">
                    <router-link to="/location">{{ $t('common.menu.locations') }}</router-link>
                    <router-link to="/location/archive" v-if="isAdmin">{{
                            $t('common.menu.removed locations')
                        }}
                    </router-link>
                    <router-link to="/location/sensors" v-if="isAdmin">{{
                            $t('common.menu.location sensors')
                        }}
                    </router-link>
                </div>
            </div>

            <div class="menu-group">
                <router-link to="/evaluation" class="title" @click.native="toggle">
                    <span class="icon ion ion-ios-medal"></span>
                    <span class="text">{{ $t('common.menu.evaluation') }}</span>
                    <span class="arrow" v-if="$store.getters.canGlobal('evaluation.editQuestions')" @click.prevent/>
                </router-link>
                <div class="content">
                    <router-link to="/evaluation/questions" v-if="$store.getters.canGlobal('evaluation.editQuestions')">
                        {{ $t('common.menu.evaluation questions') }}
                    </router-link>
                </div>
            </div>
            <div class="menu-group" v-if="$store.getters.canGlobal('communication.send')">
                <router-link to="/communication/sendMessage" class="title">
                    <span class="icon ion ion-ios-mail"></span>
                    <span class="text">{{ $t('common.menu.communication') }}</span>
                </router-link>
            </div>
            <div class="menu-group" v-if="isAdmin && !showBackToAdmin">
                <router-link to="/changeUser" class="title">
                    <span class="icon ion ion-ios-contacts"></span>
                    <span class="text">{{ $t('common.menu.change user') }}</span>
                </router-link>
            </div>
            <div class="menu-group" v-if="showBackToAdmin">
                <div class="title" @click="backToAdminPanel">
                    <span class="icon ion ion-ios-arrow-dropleft"></span>
                    <span class="text">{{ $t('common.menu.back to admin') }}</span>
                </div>
            </div>

            <div class="menu-group">
                <router-link to="/support" class="title">
                    <span class="icon ion ion-ios-help-circle"></span>
                    <span class="text">{{ $t('common.menu.help') }}</span>
                </router-link>
            </div>
        </nav>
    </aside>
</template>
<script>

import {Server} from "@/common/server/server";
import {mapGetters} from "vuex";

export default {
    methods: {
        toggle(e) {
            const group = e.currentTarget.parentNode;
            group.classList.toggle('isOpen');
            group.classList.toggle('isClose', !group.classList.contains('isOpen'));
            this.closeAllBut(group);
            this.setHeight(e.currentTarget.nextElementSibling);
        },
        focusin(e) {
            const group = Array.from(this.getParents(e.target)).find(x => x.classList.contains('menu-group'));
            const content = Array.from(this.getParents(e.target)).find(x => x.classList?.contains('content'));
            if (group && content && !group.classList.contains('isOpen')) {
                group.classList.add('isOpen');
                group.classList.remove('isClose');
                this.closeAllBut(group);
                this.setHeight(group.lastElementChild);
            }
        },
        closeAllBut(a) {
            this.$el.querySelectorAll('.isOpen').forEach(x => {
                if (x != a) {
                    x.classList.remove('isOpen');
                    x.classList.add('isClose')
                }
            })
        },
        setHeight(element) {
            if(!element){
                return;
            }
            let sum = 0;
            for (let x of element.children) {
                sum += x.clientHeight;
            }
            element.style.setProperty('--height', sum + 'px')
        },
        getParents(n) {
            let ret = []
            while (n) {
                ret.push(n);
                n = n.parentNode;
            }
            return ret;
        },
        async backToAdminPanel() {
            try {
                const {token, commonData} = await Server.ChangeUser.ChangeToAdmin()
                this.$store.commit('setToken', token)
                this.$store.commit('setCommonDataPromise', {promise: Promise.resolve(commonData), keepOld: false})
                await this.$store.dispatch('parseCommonData', commonData)
                if (this.$route.name != 'ChangeUser') {
                    await this.$router.push('/changeUser')
                }
            } catch (e) {
                this.$store.commit('showNotification', {text: this.$t(e.userVisible ? e.message : 'common.error occurred')})
            }
        }
    },
    computed: {
        ...mapGetters([
            'isAdmin',
            'isManager',
            'showAdditionalTimechekers',
            'leaveEnabled'
        ]),
        hasClearanceSlips() {
            return this.$store.state.commonData.data?.hasAnySlip
        },
        showBackToAdmin() {
            return this.$store.state.commonData.data?.user?.showBackToAdmin
        },
        isSchedulerAllowed() {
            return this.$store.getters.canAnything('schedule.show')
        },
        isTimecheckerAllowed() {
            return this.$store.getters.canAnything('timechecker.show')
        }
    }
}
</script>
